import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ScreenUtilsService } from 'core/services';
import { BehaviorSubject } from 'rxjs';
import { PdfViewerService } from '../../pdf-viewer.service';

@Component({
  selector: 'ss-pdf-title',
  templateUrl: './pdf-title.component.html',
  styleUrls: ['./pdf-title.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfTitleComponent implements OnInit {

  readonly titleSubject = new BehaviorSubject<string>(undefined)
  @Input() get title() {
    return this.titleSubject.value
  }
  set title(value) {
    this.titleSubject.next(value);
  }

  readonly numOfPagesSubject = new BehaviorSubject<number>(0)
  @Input() get numOfPages() {
    return this.numOfPagesSubject.value
  }

  set numOfPages(value: number) {
    this.numOfPagesSubject.next(value)
  }

  readonly selectedZoomSubject = this._pdfViewerService.selectedZoomSubject;
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs;

  constructor(

    private _pdfViewerService: PdfViewerService,
    private readonly _screenUtilsService: ScreenUtilsService

  ) { }

  ngOnInit(): void {
  }

}
